import Vue from 'vue'
import ElementUI from 'element-ui';
import i18n from './utils/i18n';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
Vue.use(ElementUI);
Vue.use(i18n);
Vue.config.productionTip = false

//全局组件挂载
Vue.component('CommonHomeBanner',()=>import('@/components/home-banner.vue'));
Vue.component('CommonBanner',()=>import('@/components/banner.vue'));
Vue.component('CommonCase',()=>import('@/components/case.vue'));
Vue.component('HomeFooter',()=>import('@/components/home-footer.vue'));
Vue.component('JobMenu',()=>import('@/components/job-menu.vue'));
Vue.component('MainBanner',()=>import('@/components/main-banner.vue'));
Vue.component('CommonProject',()=>import('@/components/project.vue'));
Vue.component('CommonProjectLists',()=>import('@/components/project-lists.vue'));
Vue.component('CommonBackgroundMiddle',()=>import('@/components/background-middle.vue'));
Vue.component('TplModel',()=>import('@/components/tpl-model.vue'));
Vue.component('CommonContentHtml',()=>import('@/components/content.vue'));
Vue.component('CommonCompanyTab',()=>import('@/components/company-tab.vue'));
Vue.component('CommonCompanyCert',()=>import('@/components/company-cert.vue'));
Vue.component('CommonTable',()=>import('@/components/table.vue'));
Vue.component('CommonXdTable',()=>import('@/components/xd-table.vue'));
Vue.component('CommonJob',()=>import('@/components/job.vue'));
Vue.component('CommonLogo',()=>import('@/components/tpl-logo.vue'));

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
